module.exports = __webpack_public_path__ + "./irene_0a9d00510f9217af0d810fece59e9fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/irene.png
// module id = 451
// module chunks = 0